import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import config from '../../../../../../../../../../../../../../../config'

import { loadDataTable } from './actions'

const MODULE_KEY = config.modules.report.key
const BLOCK_KEY = config.modules.report.blocks.estates.key

function mapStateToProps(state, hocProps) {
    const blockCustomData = state.getIn(
        ['ui', 'workspace', MODULE_KEY, hocProps.id, 'blocks', BLOCK_KEY, 'customData'],
        {}
    )

    return {
        blockCustomData,
        customData: _.get(blockCustomData, `ownershipListEstateDetail.${hocProps.listId}.${hocProps.objectId}`, {}),
        customDataRows: _.get(
            blockCustomData,
            `ownershipListEstateDetailRow.${hocProps.listId}.${hocProps.objectId}`,
            {}
        ),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ loadDataTable }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps, null, { areStatePropsEqual: _.isEqual })
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
